var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.g{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.d,.f,.i{fill:none;}.c,.d,.e,.f,.g{stroke:#208ce1;stroke-width:1.5px;}.c,.f,.g{stroke-linecap:round;}.c,.g{stroke-linejoin:round;}.h{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2544.03 4303.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-276.647-8217.406H-299s-7.14-4.283-8.408-4.686a2.173,2.173,0,0,0-1.459-.139,2.163,2.163,0,0,0-.875,3.116c1.125,1.5,8.93,5.813,8.93,5.813h14.72",
    transform: "translate(2.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-304-8213.3h-7.363v-9.825h-2.99v14.415h27.222"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-306.491-8208.379v2.32",
    transform: "translate(0.491)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-309 -8207)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3,
    cy: 3,
    r: 2.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-279.109-8217.807V-8242.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-276.034-8239.482h-9.746v3.19"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(-289 -8237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M0,0H7A0,0,0,0,1,7,0V6A3,3,0,0,1,4,9H3A3,3,0,0,1,0,6V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1.5.75h4a.75.75,0,0,1,.75.75V6A2.25,2.25,0,0,1,4,8.25H3A2.25,2.25,0,0,1,.75,6V1.5A.75.75,0,0,1,1.5.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-279.72-8214.621v4.73h-4.686v5.177h4.686v4.686h5.132v-4.686h5v-5.177h-5v-4.73Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality8);
export default __webpack_public_path__ + "static/media/speciality8.3af059a66fde6437184ed5a403ab7c0b.svg";
export { ForwardRef as ReactComponent };